import React from "react";

import { IActiveFacet } from "types";
import { Close } from "assets/icons";
import { i18nService } from "services";

interface ActiveFacetProps {
  activeFacet: IActiveFacet;
}

export const ActiveFacet: React.FC<ActiveFacetProps> = ({ activeFacet }) => (
  <div className="active-facet">
    <span className="active-facet__label">{activeFacet.label}: </span>
    {activeFacet.activeOptions?.map((option) => (
      <button
        key={option.label}
        className="link is-small"
        type="button"
        onClick={option.onClick}
      >
        <span className="visually-hidden">
          {i18nService.copy["a11y.remove"]}
        </span>

        <span className="link__text">{option.label}</span>
        <Close />
      </button>
    ))}
  </div>
);
